(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsManageTags', rmsManageTags);

    function rmsManageTags() {
        return {
            restrict: 'E',
            controller: rmsManageTagsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                options: '=',
                submit: '=?'
            },
            templateUrl: 'common/app/components/manage-tags'
        };
    }

    function rmsManageTagsCtrl(lodash, $scope, $timeout) {
        var vm = this;

        this.$onInit = function() {

            vm.add = add;
            vm.remove = remove;
            vm.submit = submit;

            vm.data = [
                // RETURNED DATA MUST BE SORTED ALREADY.
                {value: 'Test2', id: 2, position: 1, editable: false, removable: false},
                {value: 'Test1', id: 1, position: 2, editable: true, removable: false},
                {value: 'Test3', id: 3, position: 3, editable: false, removable: true},
                {value: 'Test5', id: 5, position: 4, editable: true, removable: true},
                {value: 'Test4', id: 4, position: 5, editable: true, removable: true}
            ];

            vm.sortableOptions = angular.merge(
                {},
                {
                    handler: '.sortable-item-handler, .sortable-item-handler .fa',
                    placeholder: function (element) {
                        return element.clone().addClass('rms-manage-tag-item-placeholder');
                    },
                    ignore: 'input,textarea',
                    change: function (e) {
                        if (e) {
                            var itemMoved = vm.data[e.oldIndex];
                            vm.data.splice(e.oldIndex, 1);
                            vm.data.splice(e.newIndex, 0, itemMoved);
                            $scope.$apply();
                        }
                        reorderRowIndex();
                    },
                },
                lodash.get(vm.options, 'sortableOptions', {})
            );
        }

        function add() {
            vm.data.push({
                id: null,
                value: '',
                editable: true,
                removable: true
            });
            reorderRowIndex();
        }

        function remove(id, position) {
            let index = lodash.findIndex(vm.data, {id: id});
            if (index === undefined) {
                index = lodash.findIndex(vm.data, {position: position});
                // after this point, index may still be undefined.
            }

            if (index !== undefined) {
                vm.data.splice(index, 1);
                reorderRowIndex();
            }
        }

        function submit() {
            console.log('submit', vm.data);
        }

        function reorderRowIndex() {
            $timeout(function () {
                angular.forEach(vm.data, (row, index) => {
                    row.position = index;
                });
            });
        }
    }
})();